import { ReactNode } from "react";
import Header from "@/components/Header";
import AppSidebar from "@/components/Sidebar";
import { Toaster } from "sonner";

type PortalLayoutProps = {
  children: ReactNode;
};

export default function PortalLayout({ children }: PortalLayoutProps) {
  return (
    <div className="min-h-screen flex w-full bg-background">
      <AppSidebar />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />

        <main className="flex-1 overflow-auto p-6">{children}</main>
      </div>

      <Toaster />
    </div>
  );
}
